import { render } from "./PartialCard.vue?vue&type=template&id=3d1b2edc"
import script from "./PartialCard.vue?vue&type=script&lang=js"
export * from "./PartialCard.vue?vue&type=script&lang=js"

import "./PartialCard.vue?vue&type=style&index=0&id=3d1b2edc&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__